var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatusTest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 4.5H9.5V5.625H4.625V7.5H5.5625L4.0625 9.375L2.5625 7.5H3.5V4.5Z",
    fill: "#007BC1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9V6H13.4375L11.9375 4.125L10.4375 6H11.375V7.875H6.5V9H12.5Z",
    fill: "#007BC1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.875 0.6C12.875 0.38998 12.875 0.28497 12.8341 0.204754C12.7982 0.134193 12.7408 0.0768251 12.6702 0.0408726C12.59 0 12.485 0 12.275 0H10.475C10.265 0 10.16 0 10.0798 0.0408726C10.0092 0.0768251 9.95183 0.134193 9.91587 0.204754C9.875 0.28497 9.875 0.38998 9.875 0.6V1.5H6.125V0.6C6.125 0.38998 6.125 0.28497 6.08413 0.204754C6.04817 0.134193 5.99081 0.0768251 5.92025 0.0408726C5.84003 0 5.73502 0 5.525 0H3.725C3.51498 0 3.40997 0 3.32975 0.0408726C3.25919 0.0768251 3.20183 0.134193 3.16587 0.204754C3.125 0.28497 3.125 0.38998 3.125 0.6V1.5H2C1.1675 1.5 0.5 2.1675 0.5 3V10.5C0.5 11.3325 1.1675 12 2 12H14C14.8325 12 15.5 11.3325 15.5 10.5L15.4925 3C15.4925 2.1675 14.8325 1.5 14 1.5H12.875V0.6ZM2 10.5V3L13.9925 3.0015L14 10.5H2Z",
    fill: "#007BC1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusTest);
export default __webpack_public_path__ + "static/media/status_test.adda440467c89ce1d7f3a0786bd3ae23.svg";
export { ForwardRef as ReactComponent };